App.controller('ZochInsuranceOccurrenceCtrl', ['$scope', '$sce', '$state', '$http', 'Config', '$mdDialog', 'zochaInsuranceService', '$timeout', '$stateParams', 'Blob', 'FileSaver', 'insuranceService', '$filter', function ($scope, $sce, $state, $http, Config, $mdDialog, zochaInsuranceService, $timeout, $stateParams, Blob, FileSaver, insuranceService, $filter) {
    $scope.stateParams = $stateParams;

    $scope.page = 'zoch_insurance';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Wystąpienie';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.home.zoch.insurance.list';
    $scope.$emit('link', $scope.link);

    if (!$scope.stateParams.declaration) {
        $state.go('root.home.zoch.insurance.list');
    }

    $scope.maxDate = new Date();
    $scope.dateOfDeath = new Date();
    $scope.declaration = $scope.stateParams.declaration;
    $scope.reason = 'EMPLOYEE_RESIGNATION';

    if ($scope.declaration.status === 'WITHDRAWN') {
        $scope.reason = $scope.declaration.withdrawalReason;
        $scope.dateOfDeath = $scope.declaration.dateOfDeath;
    }

    $scope.withdraw = function() {
        var vm = this;

        if (!vm.form.$valid) {
            return 0;
        }

        var criteria = {
            id: $scope.stateParams.declaration.id,
            data: {
                withdrawalReason: $scope.withdrawalReason
            }
        }

        if ($scope.reason === 'DEATH') {
            criteria.data.dateOfDeath = $filter('getDateFromBirthdate')($scope.dateOfDeath);
        }

        zochaInsuranceService.withdraw(criteria).then(function (data) {
            if (data.status === 200) {
                $state.go('root.home.zoch.insurance.list');
            }
        });
    }
}]);
